if (!customElements.get("column-slider")) {
  customElements.define("column-slider", class ColumnSlider extends HTMLElement {
    constructor() {
      super();

      this.mobileLayout = this.dataset.mobileLayout || 'slider';
      this.desktopLayout = this.dataset.desktopLayout || 'slider';

      this.mobileSlidesPerView = this.dataset.mobileSlidesPerView || 'auto';
      this.desktopSlidesPerView = this.dataset.desktopSlidesPerView || 'auto';

      this.mobileMediaQuery = window.matchMedia("(max-width: 749px)");
    }

    connectedCallback() {
      this.mobileMediaQuery.addEventListener('change', this.checkBreakpoint.bind(this));

      this.checkBreakpoint();
    }

    checkBreakpoint = function () {
      const allSliders = this.querySelectorAll(".swiper-column-slider");

      allSliders.forEach((slider) => {
        if ((this.mobileMediaQuery.matches && this.mobileLayout === "slider")) {
          if (!slider.swiper) {
            this.enableSlider(slider);
          }
        } else if (!this.mobileMediaQuery.matches && this.desktopLayout === "slider") {
          if (!slider.swiper) {
            this.enableSlider(slider);
          }
        } else {
          if (slider.swiper) {
            this.disableSlider(slider.swiper);
          }
        }
      });
    };

    enableSlider = function (slider) {
      const slideCount = slider.querySelectorAll(
        ".swiper-slide:not(.swiper-slide-duplicate)"
      ).length;

      if (slideCount <= 1) return;
      if (slider.swiper) return;

      const swiper = new Swiper(`#${slider.id}`, {
        observer: true,
        observeParents: true,
        breakpoints: {
          0: {
            slidesPerView: this.mobileSlidesPerView,
            spaceBetween: 20,
          },
          750: {
            slidesPerView: this.desktopSlidesPerView,
            spaceBetween: 40,
          }
        },
        pagination: {
          el: `#${this.id} .swiper-pagination`,
          clickable: true,
        },
        navigation: {
          prevEl: `#${this.id} .swiper-button-prev`,
          nextEl: `#${this.id} .swiper-button-next`,
        },
      });

      let firstResize = true;
      const sizeObserver = new ResizeObserver(() => {
        if (firstResize) {
          firstResize = false;
          return;
        }
        if (slider.swiper) slider.swiper.update();
      });
      sizeObserver.observe(slider);
      swiper._sizeObserver = sizeObserver;
    };

    disableSlider = function (slider) {
      if (slider === undefined) return;
      if (slider._sizeObserver) {
        slider._sizeObserver.disconnect();
        delete slider._sizeObserver;
      }
      slider.destroy(true, true);
    };
  });
}
